export function isRuntimeTicketAuthFailureMessage(message: string): boolean {
  const normalized = message.toLowerCase();
  return (
    normalized.includes("authentication") ||
    normalized.includes("unauthorized") ||
    normalized.includes("forbidden") ||
    normalized.includes("credential") ||
    normalized.includes("runtime ticket") ||
    normalized.includes("status 401") ||
    normalized.includes("status 403")
  );
}
